import { createAction } from 'redux-actions-helpers';

export const change = createAction('@@select/CHANGE', (id, value) => ({
    id,
    value
}));

export const changeDate = createAction('@@select/CHANGE-DATE', (date) => ({
    date
}));

export const toggle = createAction('@@select/TOGGLE', (id) => ({
    id
}));

export const closeSelect = createAction('@@select/CLOSE_SELECT');
export const resetSelect = createAction('@@select/RESET_SELECT');



// WEBPACK FOOTER //
// ./src/blocks/select/actions.js